
import { Component, Vue } from 'vue-property-decorator'
import Search from '../components/Search.vue'
import { ImageEntry, userHasRoles, UserRoles } from '@ht-lib/accounts-models'
import EditJobsTable from '@/components/EditJobsTable.vue'

@Component({
  name: 'Editing',
  components: { EditJobsTable, Search }
})
export default class extends Vue {
  created () {
    if (!userHasRoles(this.$auth.user.profile, [UserRoles.SOFTWARE_GODS, UserRoles.IMAGE_EDITING, UserRoles.IMAGE_EDITING_ADMIN])) {
      this.$router.push('/')
    }
  }

  search (x: ImageEntry[]) {
    console.log('Search', x)
  }
}
